export default __webpack_public_path__ + "static/media/download.e59d328a.svg";